function doScroll({ top, additionalVerticalOffset = 0, behavior = 'smooth' }) {
  const supportsNativeSmoothScroll = 'scrollBehavior' in document.documentElement.style;
  const pos = top + additionalVerticalOffset;

  if (supportsNativeSmoothScroll) {
    window.scrollTo({
      left: 0,
      top: pos,
      behavior,
    });
  } else {
    window.scrollTo(0, pos);
  }
}

const scrollToElement = ({ el = null, ...rest }) => {
  if (el != null) {
    const viewPortOffset = el.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    doScroll({ ...rest, top: viewPortOffset.top + scrollTop });
  }
};

const scrollToRef = ({ ref = null, ...rest }) => {
  if (ref?.current) {
    doScroll({ ...rest, top: ref.current.offsetTop });
  }
};

const scrollFirstErroredFieldIntoView = (errors, verticalOffset) => {
  if (Object.keys(errors).length > 0) {
    const elements = document.getElementsByClassName('is-error');

    if (elements.length > 0) {
      scrollToElement({ el: elements[0], additionalVerticalOffset: verticalOffset });
    }
  }
};

export { scrollToElement, scrollToRef, doScroll, scrollFirstErroredFieldIntoView };
